import { Validation } from './Validation';
import { CustomInputCategory } from './CustomInputCategory';
import { CustomInputType } from './CustomInputType';
import { CustomInputLayout } from './CustomInputLayout';

/**
 * Individuelle Inputs für Formulare
 */
export default interface CustomInputJson {
    /**
     * Kategorie des individuellen Inputs
     */
    category: CustomInputCategory;

    /**
     * Art des individuellen Inputs
     */
    type: CustomInputType;

    /**
     * Label/Titel des individuellen Inputs
     */
    label: string;

    /**
     * Ist der Input verpflichtend
     */
    required: boolean;

    /**
     * Gibt an, wie der Input angezeigt werden soll
     * [later]
     */
    layout?: CustomInputLayout;

    /**
     * Value/Content des Inputs
     */
    value: string | boolean;
}

export function defaultCustomInputJson(): CustomInputJson {
    return {
        category: CustomInputCategory.aprovel,
        type: CustomInputType.checkbox,
        label: "",
        required: false,
        value: false,
    };
 }

export function validateCustomInputJson(item: CustomInputJson) {
    return new Validation(item)
       .validateNonEmptyString("label", 100)
       .finish();
}

export function validateCustomInputJsonValue(item: CustomInputJson) {
    if(typeof item.value == "boolean") {
        return new Validation(item)
            .validateBoolean("value", false, item.required)
            .finish();
    } else {
        return new Validation(item)
            .validateString("value", 500, item.required)
            .finish();
    }
}